   
   
   <!--============================================================ Add Training program Form ============================================== -->

      <mat-dialog-content>
      <div class="tabs-container ">
          <form [formGroup]="addProgramForm" >           
                <ion-row class="pl-20">
                  <ion-col >
                    <span class="font_bold ">Add Training programme</span>
                  </ion-col>
                  <ion-col class="text-right">
                    <img [mat-dialog-close] class="close-btn" src="././assets/icon/close_icon.png">
                  </ion-col>
                </ion-row>
             

              <!-- =========================================  Training Type =============================================== -->
      
            <div class="font_medium ml-10 mr-10">
            <ion-row  class="responsive-form m-10 p-20">
              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">
                  Training Type <span class="red-cl">&nbsp;*</span>
                </div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <mat-select placeholder="Select"  formControlName="trainingType" (selectionChange)="onTrainingTypeChange($event.value)"
                  >
                  <mat-option [value]="type" *ngFor="let type of trainingTypes" class="custom-option">
                    {{ type }}
                  </mat-option>
                  </mat-select>
                  <mat-error *ngIf="addProgramForm?.get('trainingType')?.hasError('required') && addProgramForm?.get('trainingType')?.touched">
                    Training type is required
                  </mat-error>
                </mat-form-field>
              </ion-col>


              
              <!-- ========================================= program Title =============================================== -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">Programme Title <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="programTitle" placeholder="Enter title" />
                  <mat-error *ngIf="addProgramForm?.get('programTitle')?.hasError('required') && addProgramForm?.get('programTitle')?.touched">
                    Program title is required
                  </mat-error>
                </mat-form-field>
              </ion-col>


              
              <!-- =========================================  Programme Code =============================================== -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">Programme Code <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="programCode" placeholder="Enter code" />
                  <mat-error *ngIf="addProgramForm?.get('programCode')?.hasError('required') && addProgramForm?.get('programCode')?.touched">
                    Programme code is required
                  </mat-error>
                </mat-form-field>
              </ion-col>


              
              <!-- =========================================  LMS Link =============================================== -->

              <ion-col size="12" size-md="3"  *ngIf="selectedTrainingType === 'Online'">
                <div class="formLabelRegularfs16 mb-5">LMS Link<span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="lmsLink" placeholder="Enter link" />         
                  <mat-error *ngIf="addFacultyForm?.get('lmsLink')?.hasError('required') && addFacultyForm?.get('lmsLink')?.touched">
                    Link is required
                    </mat-error>
                </mat-form-field>
              </ion-col>

              
              
              <!-- =========================================  Location Of Programmme =============================================== -->

              <ion-col size="12" size-md="3" *ngIf="selectedTrainingType === 'Offline'">
                <div class="formLabelRegularfs16 mb-5">Location of Programme <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="location" placeholder="Enter location"  />
                  <mat-error *ngIf="addFacultyForm?.get('location')?.hasError('required') && addFacultyForm?.get('location')?.touched">
                  Location is required
                    </mat-error>
                </mat-form-field>
              </ion-col>

              
              <!-- =========================================  Start Date ============================================================ -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">Start Date <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput  [matDatepicker]="picker1" formControlName="startDate" placeholder="select start Date"/>
                  <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                  <mat-error *ngIf="addProgramForm?.get('startDate')?.hasError('required') && addProgramForm?.get('startDate')?.touched">
                    Start date is required
                  </mat-error>
                </mat-form-field>
              </ion-col>


              
              <!-- =========================================  End Date ======================================================== -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">End Date <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput [matDatepicker]="picker2"  formControlName="endDate" placeholder="select End Date"/>
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-error *ngIf="addProgramForm?.get('endDate')?.hasError('required') && addProgramForm?.get('endDate')?.touched">
                  End date is required
                </mat-error>
                </mat-form-field>
              </ion-col>

              <!-- ===================================== start Time ========================================================= -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">Start Time <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <mat-select formControlName="endTime" placeholder="Select Start Time" [disableOptionCentering]="true">            
                    <mat-option *ngFor="let time of timeSlots" [value]="time">{{ time }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="addProgramForm?.get('startTime')?.hasError('required') && addProgramForm?.get('startTime')?.touched">
                    Start time is required
                  </mat-error>
                </mat-form-field>
              </ion-col>
              
              
              
              <!-- =========================================  End Time ====================================================== -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">End Time <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style" >
                  <mat-select formControlName="endTime" placeholder="Select End Time" [disableOptionCentering]="true">
                    <mat-option *ngFor="let time of timeSlots" [value]="time">{{ time }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="addProgramForm?.get('endTime')?.hasError('required') && addProgramForm?.get('endTime')?.touched">
                    End time is required
                  </mat-error>
                </mat-form-field>
              </ion-col>
              
              
              
              <!-- ========================================= Functional/Behaviour =============================================== -->
              
              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">
                  Functional/Behavioral <span class="red-cl">&nbsp;*</span>
                </div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <mat-select placeholder="Select behavior"  formControlName="functionalBehavioral"
                  >
                  <mat-option [value]="option" *ngFor="let option of functionalOptions" class="custom-option">
                    {{ option }}
                  </mat-option>
                  </mat-select>
                  <mat-error *ngIf="addProgramForm?.get('functionalBehavioral')?.hasError('required') && addProgramForm?.get('functionalBehavioral')?.touched">
                  Functional/Behavioral is required
                  </mat-error>
                </mat-form-field>
              </ion-col>

        
              
              
              <!-- =========================================  Budget Cost =============================================== -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">Budget cost <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <span matPrefix class="rupee-symbol">&nbsp;₹</span>
                  <input matInput formControlName="budgetCost" placeholder="Enter Budget Cost" type="number"  />
                  <mat-error *ngIf="addProgramForm?.get('budgetCost')?.hasError('required') && addProgramForm?.get('budgetCost')?.touched">
                  Budget cost is required
                  </mat-error>
                </mat-form-field>
              </ion-col>

             
              <!-- =========================================  Actual Cost =============================================== -->   

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">Actual cost </div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <span matPrefix class="rupee-symbol">&nbsp;₹</span>
                  <input matInput formControlName="actualCost" placeholder="Enter Actual Cost" type="number"  />
                </mat-form-field>
              </ion-col>
            
              
              <!-- =========================================  Faculty Name  =============================================== -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">
                  Faculty Name <span class="red-cl">*</span>
                </div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="facultyName" placeholder="Add faculty" readonly />
                  <button matSuffix mat-button class="add-button" (click)="onClickAddNewFacultyPopup()">+ Add</button>
                
                <!-- <mat-error *ngIf="addProgramForm.get('facultyName')?.hasError('required') && addProgramForm.get('facultyName')?.touched">
                  Objective is required
                  </mat-error> -->
              </mat-form-field>
              </ion-col>


              
              <!-- =========================================  Department =============================================== -->
                
              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">
                  Dept<span class="red-cl">&nbsp;*</span>
                </div>
                <ng-multiselect-dropdown class="w-100 mat mat-height40 mat-input-style"
                [placeholder]="'Select Department'"
                [settings]="dropdownSettings"
                [data]="getDepartmentsList"      
                formControlName="department"
                (onSelect)="onDepartmentSelect()"
                (onDeSelect)="onDepartmentDeSelect()"
                (onSelectAll)="onDepartmentAllSelect()"
                (onDeSelectAll)="onDepartmentAllDeSelect()">
              </ng-multiselect-dropdown>
              <mat-error *ngIf="addProgramForm?.get('department')?.hasError('required') && addProgramForm?.get('department')?.touched">
             Department is required
                </mat-error>
              </ion-col>


              
              <!-- =========================================  Band =============================================== -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">
                  Band<span class="red-cl">&nbsp;*</span>
                </div>
                <ng-multiselect-dropdown class="w250 mat mat-height40 mat-input-style"
                [placeholder]="'Select Band'"
                [settings]="dropdownbandSettings"
                [data]="getBandList"    
                formControlName="band"
                (onSelect)="onSelectBand()"
                (onDeSelect)="onDeSelectBand()"
                (onSelectAll)="onSelectAllBand()"
                (onDeSelectAll)="onDeSelectAllBand()">
              </ng-multiselect-dropdown>
              <mat-error *ngIf="addProgramForm?.get('band')?.hasError('required') && addProgramForm?.get('band')?.touched">
               Band is required
                   </mat-error>
              </ion-col>


              
              <!-- ========================================= Grade  ================================================= -->

              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">
                  Grade<span class="red-cl">&nbsp;*</span>
                </div>
                <ng-multiselect-dropdown class="w250  mat mat-height40 mat-input-style"
                [placeholder]="'Select Grade'"
                [settings]="dropdownGradeSettings"
                [data]="getGradeList"  
                formControlName="grade"
                (onSelect)="onGradeSelect()"
                (onDeSelect)="onGradeDeselect()"
                (onSelectAll)="onGradeSelectAll()"
                (onDeSelectAll)="onGradeDeselectAll()">
              </ng-multiselect-dropdown>
              <mat-error *ngIf="addProgramForm?.get('grade')?.hasError('required') && addProgramForm?.get('grade')?.touched">
                Grade is required
                    </mat-error>
              </ion-col>

              
              <!-- =========================================  Objective  =============================================== -->
              
              <ion-col size="12" size-md="3">
                <div class="formLabelRegularfs16 mb-5">Objective <span class="red-cl">*</span></div>
                <mat-form-field class="w-100 mat-input-style">
                  <textarea matInput formControlName="objective" placeholder="Enter objective" rows="1"></textarea>
                  <mat-error *ngIf="addProgramForm?.get('objective')?.hasError('required') && addProgramForm?.get('objective')?.touched">
                    Objective is required
                  </mat-error>
                </mat-form-field>
              </ion-col>
            </ion-row>


            
              <!-- =========================================  Cancle =============================================== -->

            <ion-row style="padding-bottom: 30px;">
              <ion-col size="12" class="text-right mt-10">
                <button class="back_btn fs-14" (click)="closeDialog()">Cancel</button>
                <button type="button" class="add_btn fs-14 ml-10"
                [style.background-color]="buttonColorName"  (click)="submitTrainingProgram()">
          
              Create Training
                </button>
              </ion-col>
            </ion-row>
              </div>
            
          </form>
        </div>    
      </mat-dialog-content>
